/* eslint-disable no-undef */

window.Wized = window.Wized || [];
window.Wized.push(async (Wized) => {
  // playlist functionality
  const user = await Wized.requests.waitFor('get_user');
  const userAdmin = user.data.is_admin;

  const playlistCategories = user.data.study_group.media.calm[0].category_items;
  let currentPreviewMedia = null;

  // get the templates and clone them
  const playlistCardReviewTemplate = document.getElementsByTagName('template')[2];
  const playlistViewTemplate = document.getElementsByTagName('template')[0];
  const playlistViewItemTemplate = document.getElementsByTagName('template')[1];
  const playlistReviewContainer = document.querySelector('[data-name="playlist-review-container"]');

  const handleVideoPreviewMedia = (
    playlist,
    button,
    player,
    videoWrapper,
    itemWrapper,
    modalCloseButton
  ) => {
    modalCloseButton.addEventListener('click', () => {
      player.src = '';
      videoWrapper.style.display = 'none';
      itemWrapper.style.display = 'flex';
    });
    videoWrapper.style.display = 'block';
    itemWrapper.style.display = 'none';
    [currentPreviewMedia] = playlist.files;
    player.src = currentPreviewMedia.preview_url;
    player.play();
    currentPreviewButton = button;
  };

  const createPlaylistPreviewItem = (
    playlistViewContainer,
    modal,
    playlistCategories,
    category,
    modalCloseButton
  ) => {
    const playlists = playlistCategories
      .map((category) => {
        return category.playlist;
      })
      .flat(Infinity);
    const playlistViewItem = playlistViewItemTemplate.content.cloneNode(true);
    const playlistView = playlistViewTemplate.content.cloneNode(true);
    playlistView.querySelector('[data-name="playlist-card-title-heading"]').textContent =
      category.category_item_name;
    playlistView.querySelector('[data-name="playlist-card-title-tagline"]').textContent =
      category.category_item_info;
    playlistView.querySelector('[data-name="playlist-card-image"]').src =
      category.category_item_thumbnail.url;
    const playlistViewItemContainer = playlistView.querySelector(
      '[data-name="playlist-view_list"]'
    );
    playlistViewContainer.appendChild(playlistView);
    playlists.forEach((playlist) => {
      const previewVideoPlayer = playlistViewItem.querySelector('[data-name="preview-video"]');
      if (userAdmin) {
        new Plyr(previewVideoPlayer);
      } else {
        new Plyr(previewVideoPlayer, {
          controls: ['play', 'fullscreen'],
        });
      }
      const previewVideoPlayerWrapper = playlistViewItem.querySelector(
        '[data-name="video-wrapper"]'
      );
      const previewItemWrapper = playlistViewItem.querySelector(
        '[data-name="preview-view-list-wrapper"]'
      );

      playlistViewItem
        .querySelector('[data-name="playist-view_list_layout"]')
        .setAttribute('playlist-id', playlist.id);
      if (playlist.files.length > 0) {
        if (playlist.playlist_type === 'visual') {
          playlistViewItem.querySelector('[data-name="playlist-view-list-type"]').textContent =
            'Visual';
        } else {
          playlistViewItem.querySelector('[data-name="playlist-view-list-type"]').textContent =
            'Audio';
        }
        playlistViewItem.querySelector('[data-name="playlist-view-list_image"]').src =
          playlist.playlist_thumbnail.url;
        playlistViewItem.querySelector('[data-name="playlist-view-list-name"]').textContent =
          playlist.playlist_name;
        playlistViewItem
          .querySelector('[data-name="playlist-view-list-button"]')
          .addEventListener('click', function () {
            selectedPlaylist = playlist;
            handleVideoPreviewMedia(
              playlist,
              this,
              previewVideoPlayer,
              previewVideoPlayerWrapper,
              previewItemWrapper,
              modalCloseButton
            );
          });
        playlistViewItemContainer.appendChild(playlistViewItem);
      }
    });
  };

  const renderPlaylistReviewCards = () => {
    playlistCategories.forEach((category) => {
      const playlistCardReview = playlistCardReviewTemplate.content.cloneNode(true);
      const playlistContainer = playlistCardReview.querySelector(
        '[data-name="playlist-card-review_modalslot"]'
      );
      const button = playlistCardReview.querySelector('.modal_component .modal_button');
      const modalWrapper = playlistCardReview.querySelector('[data-name="modal_wrapper"]');
      const modalCloseButton = modalWrapper.querySelector('[data-name="modal-close-button"]');

      playlistCardReview.querySelector('[data-name="card-review-name"]').textContent =
        category.category_item_name;
      playlistCardReview.querySelector('[data-name="card-review-type"]').textContent =
        category.category_item_info;
      playlistCardReview.querySelector('[data-name="card-review-icon"]').src =
        category.category_item_thumbnail.url;
      createPlaylistPreviewItem(
        playlistContainer,
        playlistCardReview,
        category.playlist_categories,
        category,
        modalCloseButton
      );
      button.addEventListener('click', () => {
        openModal(button);
      });
      playlistReviewContainer.appendChild(playlistCardReview);
    });
    playlistReviewContainer.classList.add('swiper');
    initSliders();
  };
  renderPlaylistReviewCards();
});
